module.exports = __webpack_public_path__ + "static/media/bfresh_event_02.d0d03269.jpg";